<template>
  <VpVueForm
    id="true"
    :fields="fields"
    class="vp-p-6"
    :get="getConfig"
    width="400px"
    ref="item"
    :track="$options.track"
    track-prefix="Integration"
    track-event-name="Configured"
    cache="integration"
    collection-cache="integrations"
    feature="INTEGRATION_GMC"
    :save="save"
  >
    <template #default="{ state, response }">
      <VpPageHeader title="Google Merchant Center" />

      <VpStatusInput id="google-merchant-center" v-model="state.status" />

      <div v-if="response?.user && !connectingUser">
        <VpField
          rules="required"
          label="Merchant Account"
          name="Merchant Account"
          class="vp-mt-4"
        >
          <VpInput>
            <VpSelect
              v-model="state.merchantId"
              :options="getMerchantAccounts(response.merchantAccounts)"
            />
          </VpInput>
        </VpField>

        <VpField
          rules="required"
          label="Site Verification Code"
          name="Site Verification Code"
          class="vp-mt-4"
        >
          <VpInput>
            <VpTextBox
              v-model="state.siteVerificationCode"
              placeholder="e.g. abcd1234xyz"
            />
          </VpInput>
        </VpField>
      </div>

      <template>
        <!-- CONNECTED -->
        <VpField label="Connected As">
          <div
            v-if="response?.user && !connectingUser"
            class="vp-bg-gray-100 vp-rounded-xl vp-p-6 vp-gap-4"
          >
            <VpField label="Name">
              <p>{{ response.user.name }}</p>
            </VpField>
            <VpField label="Email">
              <p>{{ response.user.email }}</p>
            </VpField>
            <VpField label="Locale">
              <p>{{ response.user.locale }}</p>
            </VpField>

            <VyButton
              label="Disconnect"
              :loading="disconnectingUser"
              @click.native="
                checkPermission('INTEGRATION_GMC', 'delete', () => {
                  disconnect(response);
                })
              "
              class="button--warning button--solid button--sm button--rounded"
            />
          </div>

          <div v-else>
            <VyButton
              v-if="connectingUser"
              class="button--warning button--solid button--sm button--rounded"
              :loading="connectingUser"
            />
            <button
              type="button"
              v-else
              @click="connect(response.loginEndpoint)"
            >
              <img
                class="vp-w-56"
                :src="googleIcon"
                alt="Google Sign In"
                loading="lazy"
              />
            </button>
          </div>
        </VpField>
      </template>
      <p>
        <strong>Note:</strong> Only simple products can be synced to Google
        Merchant Center.
      </p>
    </template>
    <!-- :save="save" -->

    <template #footer="{ saveItem, isSaving }">
      <VyButton
        label="Save"
        @click.native="saveItem"
        :loading="isSaving"
        class="button--primary button--solid button--md button--rounded"
      />
    </template>
  </VpVueForm>
</template>

<script>
import { mapGetters } from "vuex";
import deleteUser from "./delete-user.gql";
import updateUser from "./update-user.gql";
import get from "./get.gql";
import update from "./update.gql";
import { GOOGLE_SIGN_IN } from "@shared/assets/index.js";

export default {
  data() {
    return {
      fields: [
        { name: "status", value: "inactive" },
        "siteVerificationCode",
        "merchantId",
      ],
      connectingUser: false,
      disconnectingUser: false,
      googleIcon: GOOGLE_SIGN_IN,
    };
  },

  computed: {
    ...mapGetters({
      checkPermission: "user/checkPermission",
    }),
  },

  methods: {
    connect(url) {
      window.location.href = url;
    },
    async disconnect() {
      try {
        this.disconnectingUser = true;
        await this.$mutate(deleteUser);
        this.$refs.item.refresh();
      } catch (err) {
        console.error(err);
      }
      this.disconnectingUser = false;
    },

    async checkForCode() {
      const code = this.$route.query?.code ?? null;
      if (code) {
        this.connectingUser = true;
        try {
          await this.$mutate(updateUser, {
            input: {
              code,
            },
          });
          this.$refs.item.refresh();
          window.history.replaceState(
            {},
            document.title,
            "/#" + this.$route.path
          );
        } catch (err) {
          console.error(err);
        }
        this.connectingUser = false;
      }
    },

    getConfig() {
      return this.$query(get).then(({ data }) => {
        if (this.checkPermission("INTEGRATION_GMC", "upsert")) {
          this.checkForCode();
        }
        return {
          values: data.integration.googleMerchantCenter,
          res: data.integration,
        };
      });
    },

    getMerchantAccounts(merchantOptions) {
      return merchantOptions?.map((options) => {
        return {
          label: options.accountName,
          value: options.accountId,
        };
      });
    },

    save(id, data) {
      return this.$mutate(update, {
        input: {
          ...data,
        },
      }).then(({ data }) => {
        this.$cache.evict({
          id: "ROOT_QUERY",
          fieldName: "integrations",
        });
        this.$router.push({ name: "integrations" });
        return data;
      });
    },
  },
};
</script>
